export enum InvoicingTableKeys {
  DOCKET = "docket_table",
  CONTRACT = "contract_table",
  XERO = "xero_table",
}
export enum InvoicingQueryParams {
  DOCKET_ID = "docketId",
  ACTION = "action",
  INVOICING_FOR = "for",
  CONTRACT_ID = "contractId",
  CUSTOMER_ID = "customerId",
}

export enum InvoicingActions {
  CREATE = "create",
  UPDATE = "update",
  VIEW = "view",
}

export enum InvoicingLocalKeys {
  DOCKET = "docket",
  DOCKET_INVOICING_ACTIONS = "docket_invoicing_actions",
  CONTRACT = "contract",
  INVOICING_ACTIONS = "invoicing_actions",
}

export const InvoicingToastMessages = {
  DOCKET: {
    CREATED: "Docket invoiced successfully",
    UPDATED: "Docket invoice updated successfully",
    DELETED: "Invoiced Work docket deleted successfully",
    TABLE_UPDATED: "Docket invoice table updated ",
  },
  CONTRACT: {
    CREATED: "Contract invoice created successfully.",
    UPDATED: "Contract invoice updated successfully",
    DELETED: "Invoiced Contract deleted successfully",
    TABLE_UPDATED: "Contract invoice table updated",
  },
  XERO: {
    TABLE_UPDATED: "Xero invoice table updated",
    XERO_INVOICES_SYNCED: "Xero invoices synced successfully",
  },
  UTILS: {
    NO_TRACKING_ITEMS:
      "No tracking items found. Please add tracking items first",
    DOCKET_ALREADY_SELECTED:
      "This docket is already selected. Remove it from the table if needed.",
  },
  ALLOCATED: "Invoice allocated successfully",
  TOTAL_NOT_NEG: "Total cannot be negative",
};

export enum Invoicing_Enums {
  DOCKET_INVOICING = "Docket Invoicing",
}

export enum InvoicingPageTitles {
  DOCKET = "Docket Invoice",
  CONTRACT = "Contract Invoice",
  XERO = "Xero Invoice",
}

export const ContractInvoiceType = {
  READY_TO_INVOICE: "READY_TO_INVOICE",
  CONTRACT_INVOICE: "CONTRACT_INVOICE",
};

export const EmptyContractInvoiceTableMessage = {
  READY_TO_INVOICE: {
    TITLE: "No Invoicing Contracts",
    SUBTITLE: "Create a claims ready for invoicing.",
  },
  CONTRACT_INVOICE: {
    TITLE: "No Invoiced Contracts",
    SUBTITLE: "Invoice a contract invoicing to view it here.",
  },
  XERO_INVOICE: {
    TITLE: "No Xero Invoices",
    SUBTITLE: "create invoices to view them here.",
  },
};

export const DocketInvoiceType = {
  READY_TO_INVOICE: "READY_TO_INVOICE",
  DOCKET_INVOICE: "DOCKET_INVOICE",
};

export const EmptyDocketInvoiceTableMessage = {
  READY_TO_INVOICE: {
    TITLE: "No Invoicing Dockets",
    SUBTITLE: "Create a work docket ready for invoicing.",
  },
  DOCKET_INVOICE: {
    TITLE: "No Invoiced Dockets",
    SUBTITLE: "Invoice a work docket to view it here.",
  },
  XERO_INVOICE: {
    TITLE: "No Xero Invoices",
    SUBTITLE: "create invoices to view them here.",
  },
};

export const InvoicingConstants = {
  UTILS: {
    ADD_DOCKET: "Add Docket",
    DOCKETS: "Dockets",
    CREATE: "Create",
    VIEW_DOCKETS: "View Dockets",
    VIEW_CLAIMS: "View Claims",
    SUMMARY: "Summary",
    SUB_TOTAL: "Sub Total",
    TOTAL_DISCOUNT: "Total Discount",
    TOTAL_TAX: "Total Tax",
    TOTAL_AMOUNT: "Total Amount",
    NOT_INVOICED: "Not Invoiced",
    SYNC_WITH_XERO: "Sync with Xero",
  },
  PROJECT_SELECT_CONFITMATION: {
    TITLE: "Select Project",
    DESC: "Select a project you'd like to create an invoice for.",
    CONFIRM_BTN_LABEL: "Create Invoice",
    CANCEL_NAME: "Cancel",
  },
};

export enum InvoicingStatus {
  DRAFT = "DRAFT",
  INVOICED = "INVOICED",
  PAID = "PAID",
  AUTHORISED = "AUTHORISED",
}

export enum ContractInvoiceStatus {
  ONGOING = "ONGOING",
  DELETED = "DELETED",
}
